import { WorkspaceEmailSendingDomainsIndexRoute } from './-components';
import type { SparklesTarget } from '@/pages/workspaces/settings/actions/email/sparkles-cue';
import { createFileRoute } from '@tanstack/react-router';

/**
 * `sparkles` marks an arrival from a workspace-setup checklist and names the
 * step it came from; the page sparkles the affordance that step is about.
 */
type SendingDomainsIndexSearch = {
  sparkles?: SparklesTarget;
};

function parseSparklesTarget(value: unknown): SparklesTarget | undefined {
  return value === 'verifyDomain' || value === 'fromAddress' ? value : undefined;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/')(
  {
    component: WorkspaceEmailSendingDomainsIndexRoute,
    // validateSearch replaces this route's search, so the incoming params are
    // spread through to preserve global ones the page doesn't own.
    // oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
    validateSearch: (search: Record<string, unknown>): Record<string, unknown> & SendingDomainsIndexSearch => ({
      ...search,
      sparkles: parseSparklesTarget(search.sparkles),
    }),
  },
);
